module.exports = __webpack_public_path__ + "static/media/b2_p5_scout.de54f200.mp3";